module.exports = __webpack_public_path__ + "media/images/ui__arrowRightInactive--dark-7f748caa8e3911d865fa4ff7b4f28a6b.png";